import { fetch } from "whatwg-fetch";

export function postJSON({ url, data = {}, type = "POST" }) {
  return fetch(url, {
    body: JSON.stringify(data),
    credentials: "same-origin",
    method: type,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "X-CSRF-Token": getToken(),
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    // app returns some head :ok as json content-type with no content
  })
    .then((response) => {
      if (response.ok) {
        return response.text();
      } else {
        return JSON.stringify({ error: true });
      }
    })
    .then((data) => {
      return data.length == 0 ? null : JSON.parse(data);
    });
}

export const getToken = () => {
  return document
    .querySelector("meta[name='csrf-token']")
    .getAttribute("content");
};

export function getJSON({ url, data = {} }) {
  let nUrl = new URL(url, document.location);

  let headers = {
    "X-Requested-With": "XMLHttpRequest",
    //  "Content-Type": "application/json",
    Accept: "application/json",
  };

  if (data.token == true) {
    delete data.token;
    headers["X-CSRF-Token"] = getToken();
  }

  Object.keys(data).forEach((key) => nUrl.searchParams.append(key, data[key]));

  return fetch(nUrl, {
    method: "GET",
    mode: "cors",
    headers: headers,
  }).then((response) => response.json());
}

// loadScript(src).then(()=>{}).catch(()=>{})
export function loadScript(url) {
  return new Promise(function (resolve, reject) {
    let newScript = document.createElement("script");
    newScript.onerror = reject;
    newScript.onload = resolve;
    let prior =
      document.currentScript || document.getElementsByTagName("script")[0];
    prior.parentNode.insertBefore(newScript, prior);
    newScript.src = url;
  });
}
